import React from 'react';

const PACKAGES = [
  {
    id: 1,
    title: 'Coin Speaker',
    subtitle: 'Coinspeaker is a leading online news platform established in 2014, specializing in comprehensive coverage of cryptocurrency sectors.',
    price: 1000,
    domain: 'https://www.coinspeaker.com/',
    features: ['Links Type: No-Follow', 'Maximum Allowed Links: 1', 'Article length: Up to 500 words', 'Coin Speaker'],
  },
  {
    id: 2,
    title: 'Bangkok Post',
    subtitle: 'BangkokPost.com is Thailand\'s leading English-language news website, delivering trusted coverage on national, regional, and global affairs.',
    price: 1000,
    domain: 'https://www.bangkokpost.com/',
    features: ['Bangkok Post', 'Links (No-Follow)', 'Maximum Allowed Links: 2', 'Maximum Allowed Images: 1', 'Maximum article length: 500 words'],
  },
  {
    id: 3,
    title: 'U.Today (Press Release)',
    subtitle: 'U.Today is a leading global media outlet providing up-to-date news, analysis, and insights on blockchain, cryptocurrency, and emerging technologies.',
    price: 1000,
    domain: 'https://u.today/press-releases',
    features: ['Maximum Allowed Images: 1', 'U.Today', 'Links (No-Follow)', 'Maximum Allowed Links: 2', 'Maximum article length: 500 words'],
  }
];

export default function GuestPackages() {
  return (
    <div style={styles.container}>
      <h2 style={styles.pageTitle}>Guest Posting Packages</h2>
      
      <div style={styles.grid}>
        {PACKAGES.map((pkg) => (
          <div key={pkg.id} className="card" style={styles.card}>
            <div style={styles.cardTop}>
              <h3 style={styles.pkgTitle}>{pkg.title}</h3>
              <p style={styles.pkgSubtitle}>{pkg.subtitle}</p>
              <div style={styles.price}>${pkg.price}</div>
              <div style={styles.domain}>Domain: {pkg.domain}</div>
            </div>

            <div style={styles.features}>
              {pkg.features.map((f, i) => (
                <div key={i} style={styles.featureItem}>
                  <span style={styles.check}>✓</span> {f}
                </div>
              ))}
            </div>

            <div style={styles.cardBottom}>
              <button style={styles.btnOutline}>Pay With PayPal</button>
              <button style={styles.btnOutline}>Pay With Crypto</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '1200px' },
  pageTitle: { marginBottom: '1.5rem', fontSize: '1.25rem', color: '#333' },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '1.5rem',
  },
  card: { display: 'flex', flexDirection: 'column', padding: 0, overflow: 'hidden' },
  cardTop: {
    padding: '2rem 1.5rem 1.5rem',
    textAlign: 'center',
    borderBottom: '1px solid #e5e7eb',
    minHeight: '220px',
  },
  pkgTitle: { fontSize: '1.1rem', fontWeight: 700, color: '#333', marginBottom: '1rem' },
  pkgSubtitle: { fontSize: '0.85rem', color: '#666', marginBottom: '1rem', lineHeight: 1.4 },
  price: { fontSize: '1.75rem', fontWeight: 700, color: '#1a62d5', marginBottom: '1rem' },
  domain: { fontSize: '0.8rem', color: '#444' },
  features: { padding: '1.5rem', flex: 1, borderBottom: '1px solid #e5e7eb' },
  featureItem: {
    display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9rem', color: '#444', marginBottom: '0.75rem'
  },
  check: { color: '#10b981', fontWeight: 'bold' },
  cardBottom: {
    padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', textAlign: 'center'
  },
  btnOutline: {
    padding: '0.6rem', border: '1px solid #1a62d5', background: 'none', color: '#1a62d5', borderRadius: '4px', fontSize: '0.9rem', fontWeight: 500, cursor: 'pointer', transition: 'background 0.2s',
  }
};
